import { render, staticRenderFns } from "./DataButton.vue?vue&type=template&id=514367ec&scoped=true"
import script from "./DataButton.vue?vue&type=script&lang=js"
export * from "./DataButton.vue?vue&type=script&lang=js"
import style0 from "./DataButton.vue?vue&type=style&index=0&id=514367ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514367ec",
  null
  
)

export default component.exports